// extracted by mini-css-extract-plugin
module.exports = {"productLink":"PopularProducts_productLink__1f9Ud"};